<template>
  <div class="field">
    <label v-if="label.length">{{ label }}</label>
    <input
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="$emit('onChange', $event.target.value)"
        type="text"
    />
  </div>
</template>

<script>
export default {
  name: "IputField.vue",
  props: [
      "modelValue",
      "label"
  ],
};
</script>

<style scoped></style>